import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetHousesQuery } from '../drApi/drApi';
import TitleBar from '../detailsPageComponents/TitleBar';
import CardsContainer from '../cards/CardsContainer';
import HouseSapSettingsCard from './HouseSapSettingsCard';
import TestDailyDataCard from './TestDailyDataCard';

const isTestDataEnvironment = ['dev', 'test', 'local-dev'].includes(process.env.REACT_APP_DEPLOY_ENV);

const HouseDetails = () => {
  const { t } = useTranslation();
  const { houseId } = useParams();
  const { data: houses = [], isLoading } = useGetHousesQuery();
  const house = houses.find((h) => h._id === houseId);

  if (isLoading) {
    return <TitleBar title={t('Haus wird geladen')} isLoading />;
  }

  if (!house) {
    return <TitleBar title={t('Haus nicht gefunden')} />;
  }

  return (
    <>
      <TitleBar title={house.name} />
      <CardsContainer vertical>
        <HouseSapSettingsCard house={house} />
        {isTestDataEnvironment && <TestDailyDataCard house={house} />}
      </CardsContainer>
    </>
  );
};

export default HouseDetails;
